module.exports = __webpack_public_path__ + "img/1261623294.d64600ca.jpg";